<template>
  <div class="row not-found center-xs middle-xs">
    <div>
      <h1>{{alert}}</h1>
      Você será redirecionado para a página inicial em {{this.count}}
    </div>
  </div>
</template>

<script>


export default {
  name: 'home',
  created() {
    this.$emit('title-change', 'Erro #404');
    this.counter();
  },
  data () {
    return {
      alert: 'Página não encontrada.',
      msg: "",
      count: 5,
      timer: null,
    }
  },
  methods: {
    counter() {
      this.count--;
      if (!this.count) this.$router.push({ path: '/monitoring' });
      else this.timer = setTimeout(this.counter,1000);
    }
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  }
}
</script>


<style scoped>
.not-found {
  height: 80vh;
}
</style>
